import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import IconLabel from '@fmbt/ui/IconLabel';
import type { IconType } from '@fmbt/ui/icons';
import { galleryCardClass } from '@fmbt/ui/layout';
import DefaultCard from 'components/atoms/DefaultCard';
import { blue } from 'style/colour-palette';
import { MAX_WIDTH_MOBILE } from 'style/constants';

import './styles.less';

interface OperationCardProps {
  title: string;
  caption: string;
  Icon: IconType;
  onClick: () => void;
}

function OperationCard({ title, caption, Icon, onClick }: OperationCardProps): JSX.Element {
  const isMobile = useMediaQuery({ maxWidth: MAX_WIDTH_MOBILE });
  return (
    <DefaultCard
      className={galleryCardClass('OperationCard')}
      onClick={onClick}
    >
      <IconLabel
        icon={<Icon size={isMobile ? 40 : 28} color={blue} />}
        gap={16}
        label={(
          <div className="vertical-gap-8">
            <div className="section-heading">{title}</div>
            <div className="body-muted-copy">{caption}</div>
          </div>
        )}
      />
    </DefaultCard>
  );
}

export default memo(OperationCard);
